<template>
    <MainContentSearchable
        title="Boletines envíados"
        id="boletines"
        v-model="filters"
        :meta="loading ? {} : boletines.meta"
        :disabled="loading"
        @updated="debouncedGetBoletines"
    >
        <template v-slot:header>
            <h3 class="card-title pt-2">Boletines envíados</h3>
            <div class="card-tools mb-3">
                <router-link
                    :to="{ name: 'back.emails.boletines.crear' }"
                    class="btn btn-primary"
                    id="crear-boletin"
                >
                    Crear boletín
                </router-link>
            </div>
        </template>

        <template v-slot:content>
            <b-row>
                <b-col cols="12">
                    <ContainerTable :data="boletines.data" :responsive="esMovil">
                        <b-table
                            hover
                            :items="boletines.data"
                            :fields="fields"
                            :busy="loading"
                        >
                            <template #cell(estado)="{ item }">
                                <b-alert
                                    show
                                    :variant="item.estado === 'Enviado' ? 'success' : 'danger'"
                                    class="p-1 mb-0"
                                    style="width: 110px; margin-left: auto; margin-right: auto"
                                >
                                    <template v-if="item.estado === 'Enviado'">
                                        <i class="fas fa-check-circle mr-1"></i>
                                        Enviado
                                    </template>
                                    <template v-else>
                                        <i class="fas fa-times-circle text-warning mr-1"></i>
                                        No enviado
                                    </template>
                                </b-alert>
                            </template>
                            <template #cell(opciones)="{ item }">
                                <OpcionesDropdownTableComponent
                                    :options="[
                                        {
                                            to: {
                                                name: 'back.emails.boletines.show',
                                                params: { id: item.id },
                                            },
                                            label: 'Ver boletín',
                                        },
                                    ]"
                                />
                            </template>
                        </b-table>
                    </ContainerTable>
                </b-col>
            </b-row>
        </template>
    </MainContentSearchable>

</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import apiService from '@/services/api-comunicados';
    import ContainerTable from '@/components/backend/common/ContainerTable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import _ from 'lodash';

    export default {
        data() {
            return {
                loading: false,
                fields: [
                    { key: "asunto", label: "Asunto" },
                    { key:"remitente.nombre", label:"Remitente", class: "text-center" },
                    { key:"total_emails_enviados", label: "Emails envíados", class: "text-center" },
                    { key:"total_visualizaciones", label: "Visualizaciones", class: "text-center" },
                    { key:"total_clics", label: "Clicks", class: "text-center" },
                    { key: "estado", label: "Estado", class: "text-center" },
                    { key: "fecha_creacion", label: "Creado en", class: "text-center" },
                    { key: "fecha_ultimo_envio", label: "Fecha de último envío", class: "text-center" },
                    { key: "opciones", label: "Opciones", class: "text-center" }
                ],
                filters: {
                    search_asunto: '',
                    estado: 1,
                    per_page: 10,
                    page: 1
                },
                boletines: {
                    data: [],
                    meta: { current_page: 1, per_page: 10 }
                },
            }
        },
        created() {
            this.getBoletines();
            this.debouncedGetBoletines = _.debounce(this.getBoletines, 500);
        },
        methods: {
            async getBoletines(resetCategory = false) {
                if (resetCategory) {
                    this.filters.carpeta_comunicado = null;
                }

                this.loading = true;
                try {
                    const filtrosApi ={ ...this.filters, search_asunto: this.filters.search };
                    this.boletines = await apiService.getBoletines(filtrosApi);
                } catch (error) {
                    this.$toast.error('Error al obtener boletines: ' + error.message);
                } finally {
                    this.loading = false;
                }
            },
        },
        computed: {
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        components: {
            MainContentSearchable, ContainerTable, OpcionesDropdownTableComponent
        }
    }
</script>
